import { Separator, SocialSharingGroup } from '@change/ds-core-ui/next';

import { CopyLinkVisibleUrlButton } from 'src/app/shared/components/CopyLinkVisibleUrlButton';
import { SocialIconWithSuccessState } from 'src/app/shared/components/SocialIconWithSuccessState';

import { useShareActions } from './hooks/useShareActions';

export const ShareActions = () => {
	const { data } = useShareActions();

	const { first, rest } = data;

	if (rest.length === 0) return null;

	return (
		<>
			{first && (
				<CopyLinkVisibleUrlButton
					url={first.url}
					urlDescription={first.secondaryLabel}
					action={first.action}
					channel={first.channel}
					label={first.label}
					successLabel={first.successLabel}
					data-qa="psf-share-copy-button"
				/>
			)}

			<Separator orientation="horizontal" className="m-0" />

			<SocialSharingGroup layout="grid" className="items-start justify-items-center gap-y-8 md:grid-cols-5">
				{rest.filter(Boolean).map((actionItem) => (
					<SocialIconWithSuccessState
						key={actionItem.channel}
						data-qa={`psf-share-${actionItem.channel}-button`}
						action={actionItem.action}
						icon={actionItem.icon}
						label={actionItem.label}
						successLabel={actionItem.successLabel}
						variant={actionItem.variant}
						className="text-center"
					/>
				))}
			</SocialSharingGroup>
		</>
	);
};
